import cn from 'classnames';
import React, { memo } from 'react';

import getDictionaryValue from '@sravni/vitrina/lib/helpers/getDictionaryValue';
import type IDictionaryComponentConfig from '@sravni/vitrina/lib/types/config/components/IDictionaryComponentConfig';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';


import { useDictionaries, useProductConfig } from '../../../../../../store/hooks/productPopupInfo';

import style from './style.module.scss';

interface IProps {
  product: IProduct;
  componentConfig: IDictionaryComponentConfig;
  className?: string;
  formattedText?: string;
}

const Dictionary = memo(({ product, componentConfig, className, formattedText }: IProps) => {
  const dictionaries = useDictionaries();
  const vitrinsConfig = useProductConfig();

  const text = formattedText || getDictionaryValue(product, componentConfig, vitrinsConfig, dictionaries);

  return <div className={cn(style.text, className)}>{text}</div>;
});

export default Dictionary;
